import axios from 'axios';

export const login = async (credentials) => {
  const response = await axios.post('https://api.collegeall.com/api/v1/admin/login', credentials);
  return response.data;
};

export const Logout = () => {
  localStorage.removeItem('adminToken');
};